<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-dialog :visible.sync="dialogVisible"
    :width="width"

    :before-close="handleClose"
  >

  <div slot="title">
    逾期配置
    <el-tooltip class="item" placement="right-start">
      <div slot="content">
        <p>可设置逾期区间，根据逾期区间判断逾期程度</p>
        <p>轻度逾期：指逾期程度较轻</p>
        <p>中度逾期：指逾期程度较严重</p>
        <p>重度逾期：指逾期程度非常严重</p>
      </div>
      <i class="el-icon-info"></i>
    </el-tooltip>
  </div>

    <!-- 配置 -->
    <div class="mb16">
      <span class='mr16'>轻度逾期</span>
      <el-input class="config-input" v-model="dataRange_1[0]"  disabled /> 天
      <span class="pl8 pr8">~</span>
      <el-input-number class="config-input" v-model="dataRange_1[1]" :min="1" :max="dataRange_1_1_max" @change="handleChange" /> 天
    </div>
    <div class="mb16">
      <span class='mr16'>中度逾期</span>
      <el-input class="config-input" v-model="dataRange_2[0]" disabled /> 天
      <span class="pl8 pr8">~</span>
      <el-input-number class="config-input" v-model="dataRange_2[1]" :min="dataRange_2[0]" :max="dataRange_2_1_max" /> 天
    </div>
    <div class="mb16">
      <span class='mr16'>重度逾期</span>
      <el-input class="config-input" v-model="dataRange_3[0]" :min="dataRange_2[1] + 1" :max="dataRange_3_0_max" disabled /> 天
      <span class="pl8 pr8">~</span>
      <el-input class="config-input" v-model="dataRange_3[1]"  disabled /> 天
    </div>

    <div slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { overdueConfigDetail, overdueConfigSave } from '@/api/domain/orders'

export default {
  components: {
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    title: {
      type: String,
      default: '逾期配置',
    },
    width: {
      type: String,
      default: '390px',
    },
  },
  data() {
    return {
      dataRange_1: [],
      dataRange_2: [],
      dataRange_1_1_max: 88,
      dataRange_2_1_max: 89,
      dataRange_3_0_max: 90,
    }
  },
  computed: {
    dataRange_3() {
      return [this.dataRange_2[1] + 1, 'n']
    },
  },
  created() {
    this.overdueConfigDetail()
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleConfirm() {
      this.overdueConfigSave()
    },
    // 配置明细
    async overdueConfigDetail() {
      const { code, data } = await overdueConfigDetail()
      if (code === 1) {
        for (const item of data) {
          if (item.type === 3) {
            continue
          }
          this[`dataRange_${item.type}`] = [item.startVal || 1, item.endVal || 1]
        }
      }
    },
    // 配置保存
    async overdueConfigSave() {
      const params = {
        configList: [
          { type: 1, startVal: this.dataRange_1[0], endVal: this.dataRange_1[1] },
          { type: 2, startVal: this.dataRange_2[0], endVal: this.dataRange_2[1] },
          { type: 3, startVal: this.dataRange_3[0], endVal: 999 },
        ],
      }

      for (const item of params.configList) {
        if (item.endVal < item.startVal) {
          this.$message.error('同一阶段，右侧不能小于左侧')
          return
        }
      }

      const { code } = await overdueConfigSave(params)

      if (code === 1) {
        this.$message.success('配置成功')
        this.handleClose()
        this.$emit('refresh')
      }
    },
    handleChange(val) {
      this.dataRange_2[0] = val + 1
    },
  },
}
</script>

<style scoped lang="scss">
.config-input {
  width: 100px;
}
</style>
